(function() {
  'use strict';

  window.TC_updateSSCutline = function(card, cut) {
    if (!card) return;
    
    const cutlineElement = card.querySelector('.product-grid-item__cutline');
    if (cutlineElement && cut) {
      cutlineElement.textContent = cut;
    }
  };

  // Override the problematic upsertProductBadge function
  if (window.upsertProductBadge) {
    const originalUpsertProductBadge = window.upsertProductBadge;
    window.upsertProductBadge = function(params) {
      try {
        // Call the original function but wrap it in try-catch
        return originalUpsertProductBadge.call(this, params);
      } catch (error) {
        console.warn('Error in upsertProductBadge:', error);
        // Fallback: try to handle badges ourselves
        if (params && params.cardInner) {
          const { cardInner, hasCoreBadge, textBadgeValue } = params;
          // Remove old core badges (keep this for safety)
          const oldCores = cardInner.querySelectorAll('.product__badge-core[data-product-badge-core]');
          oldCores.forEach(el => el.remove());
          // Find or create badge container
          let badgeContainer = cardInner.querySelector('.product__badge[data-product-badge]');
          if (!badgeContainer) {
            const imageWrapper = cardInner.querySelector('.product-grid-item__image');
            if (imageWrapper) {
              badgeContainer = document.createElement('div');
              badgeContainer.className = 'product__badge';
              badgeContainer.setAttribute('data-product-badge', '');
              imageWrapper.insertAdjacentElement('afterbegin', badgeContainer);
            }
          }
          if (badgeContainer) {
            // Use helpers to add/update both badges without clearing container
            if (typeof window.upsertTextBadge === 'function') {
              window.upsertTextBadge(badgeContainer, textBadgeValue);
            } else {
              // fallback: add text badge manually if helper not present
              let textBadgeItem = badgeContainer.querySelector('.product__badge__item--custom');
              if (textBadgeValue) {
                if (textBadgeItem) {
                  const span = textBadgeItem.querySelector('span');
                  if (span) {
                    span.textContent = textBadgeValue;
                  } else {
                    textBadgeItem.textContent = textBadgeValue;
                  }
                  textBadgeItem.style.display = '';
                  textBadgeItem.style.visibility = 'visible';
                } else {
                  textBadgeItem = document.createElement('div');
                  textBadgeItem.className = 'product__badge__item product__badge__item--custom';
                  const span = document.createElement('span');
                  span.textContent = textBadgeValue;
                  textBadgeItem.appendChild(span);
                  badgeContainer.insertAdjacentElement('afterbegin', textBadgeItem);
                }
              } else if (textBadgeItem) {
                textBadgeItem.remove();
              }
            }
            if (typeof window.upsertCoreBadge === 'function') {
              window.upsertCoreBadge(badgeContainer, hasCoreBadge);
            } else if (hasCoreBadge && window.getCoreBadgeMarkup) {
              // fallback: add core badge manually if helper not present
              const coreItem = document.createElement('div');
              coreItem.className = 'product__badge__item product__badge-core';
              coreItem.setAttribute('data-product-badge-core', '');
              coreItem.innerHTML = window.getCoreBadgeMarkup();
              badgeContainer.appendChild(coreItem);
            }
          }
        }
      }
    };
  }

  const CORE_BADGE_TAG = 'badge:core-collection';

  function normalizeTags(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(t => t.toLowerCase());
    if (typeof tags === "string") return tags.split(",").map(t => t.trim().toLowerCase());
    return [];
  }

  function productHasCoreBadgeFromTags(tags) {
    return normalizeTags(tags).includes(CORE_BADGE_TAG);
  }

  function getCoreBadgeMarkup() {
    const source = window.theme?.settings?.core_badge_source;
    const img = window.theme?.settings?.core_badge_image;

    if (source === "image" && img) {
      return `
        <div class="product__core-badge product__badge__item" data-product-core-badge="">
          <img src="${img}" alt="Core Collection" loading="lazy" />
        </div>
      `;
    }

    return `
      <div class="product__core-badge product__badge__item" data-product-core-badge="">
        <svg width="74" height="15" viewBox="0 0 74 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_8564_117322)">
            <path d="M0.75293 6.65442C0.75293 3.48611 3.27793 0.905762 6.43835 0.905762C8.37085 0.905762 10.0542 1.76034 11.1 3.10576L9.17168 4.7178C8.45918 3.80826 7.49835 3.32555 6.43835 3.32555C4.59668 3.32555 3.22085 4.73445 3.22085 6.65442C3.22085 8.57439 4.59668 10.0001 6.43835 10.0001C7.49835 10.0001 8.45918 9.50111 9.17168 8.60769L11.1 10.2199C10.0542 11.647 8.37085 12.5183 6.43835 12.5183C3.27793 12.5016 0.75293 9.82272 0.75293 6.65442Z" fill="currentColor"/>
            <path d="M11.8345 6.67086C11.8345 3.38594 14.5258 0.905762 17.8924 0.905762C21.259 0.905762 23.9503 3.38594 23.9503 6.67086C23.9503 9.93913 21.2756 12.4352 17.8924 12.4352C14.5091 12.4352 11.8345 9.95578 11.8345 6.67086ZM21.4824 6.67086C21.4824 4.66761 20.0569 3.32568 17.8924 3.32568C15.7278 3.32568 14.3024 4.66761 14.3024 6.67086C14.3024 8.65747 15.7445 10.0161 17.8924 10.0161C20.0403 10.0161 21.4824 8.67412 21.4824 6.67086Z" fill="currentColor"/>
            <path d="M25.6162 1.1588H30.4688C33.3031 1.1588 34.9281 2.93327 34.9281 5.16975C34.9281 6.37979 34.5478 7.44 33.787 8.25053L35.9605 12.1653H33.1963L31.5478 9.00922H28.084V12.1653H25.6162V1.1588ZM32.3605 5.16975C32.3605 4.21021 31.6813 3.55949 30.4188 3.55949H28.0674V6.78013H30.4188C31.6979 6.79678 32.3605 6.14606 32.3605 5.16975Z" fill="currentColor"/>
            <path d="M37.5625 1.1588H47.1171V3.52619H40.0303V5.61264H46.5463V7.98003H40.0137V9.81488H47.1338V12.1821H37.5625V1.1588Z" fill="currentColor"/>
            <path d="M54.8584 7.07856C54.8584 9.19861 56.5251 10.0532 58.6063 10.0532C59.5005 10.0532 60.3113 9.91995 61.1555 9.59626V12.0488C60.2113 12.3351 59.0697 12.4684 58.0022 12.4684C54.8418 12.4684 52.3907 10.7739 52.3907 7.07856V1.54184H48.9241V3.4268H50.6908V5.84469H48.9241V7.72938H50.6908V10.1471H48.9408V12.5318H54.8418V7.07856H54.8584Z" fill="currentColor"/>
            <path d="M62.9062 1.1588H70.1499C72.7178 1.1588 74.1265 2.75008 74.1265 4.9035C74.1265 5.94683 73.6465 6.87357 72.6678 7.4676L74.6241 12.1653H72.0137L70.4319 8.25051H65.374V12.1821H62.9062V1.1588ZM70.1333 3.47625H65.374V6.01342H70.0333C70.9774 6.01342 71.5732 5.46238 71.5732 4.75218C71.5732 4.0415 70.9774 3.4906 70.1333 3.47625Z" fill="currentColor"/>
          </g>
          <defs>
            <clipPath id="clip0_8564_117322">
              <rect width="73.3913" height="14" fill="white" transform="translate(0.75293 0.905762)"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    `;
  }

  function ensureBadgeContainer(cardInner) {
    let badgeWrapper = cardInner.querySelector(".product__badge");
    if (!badgeWrapper) {
      badgeWrapper = document.createElement("div");
      badgeWrapper.className = "product__badge";
      badgeWrapper.setAttribute("data-product-badge", "");
      cardInner.insertAdjacentElement("afterbegin", badgeWrapper);
    }
    return badgeWrapper;
  }

  function upsertCoreBadge(parentElementOrWrapper, hasCoreBadge) {
    const badgeWrapper = parentElementOrWrapper.querySelector ? parentElementOrWrapper : null;
    if (!badgeWrapper) return;

    let core = badgeWrapper.querySelector(".product__core-badge");

    if (hasCoreBadge) {
      if (!core) {
        core = document.createElement("div");
        core.className = "product__core-badge";
        core.setAttribute("data-product-core-badge", "");
        core.innerHTML = getCoreBadgeMarkup().trim();
        badgeWrapper.appendChild(core.firstElementChild || core);
      }
    } else if (core) {
      core.remove();
    }
  }

  function upsertTextBadge(badgeWrapper, badgeValue) {
    if (!badgeWrapper) return;
    
    // Remove any direct span that doesn't have proper classes
    const directSpan = badgeWrapper.querySelector(":scope > span:not(.product__badge__item)");
    if (directSpan) {
      directSpan.remove();
    }
    
    let textBadgeItem = badgeWrapper.querySelector(".product__badge__item--custom");

    if (badgeValue) {
      if (textBadgeItem) {
        // Update existing badge item
        const span = textBadgeItem.querySelector("span");
        if (span) {
          span.textContent = badgeValue;
        } else {
          textBadgeItem.textContent = badgeValue;
        }
        textBadgeItem.style.display = "";
        textBadgeItem.style.visibility = "visible";
      } else {
        // Create new badge item
        textBadgeItem = document.createElement("div");
        textBadgeItem.className = "product__badge__item product__badge__item--custom";
        const span = document.createElement("span");
        span.textContent = badgeValue;
        textBadgeItem.appendChild(span);
        badgeWrapper.insertAdjacentElement("afterbegin", textBadgeItem);
      }
    } else if (textBadgeItem) {
      textBadgeItem.remove();
    }
  }

  function removeBadgeWrapperIfEmpty(badgeWrapper) {
    // Don't remove the wrapper anymore - keep it for compatibility
    return;
  }

  async function fetchProductData(handle) {
    if (!handle) return null;
    
    let cleanHandle = handle;
    
    if (handle.includes('https://') || handle.includes('http://')) {
      const url = new URL(handle);
      cleanHandle = url.pathname;
    }
    
    cleanHandle = cleanHandle.replace('/products/', '').split('?')[0];
    
    try {
      const response = await fetch(`/products/${cleanHandle}.js`);
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  async function processSSRecommendationItem(item) {
    try {
      if (!item) return;
      
      const innerElement = item.querySelector(".ss__result__inner") || item.querySelector(".card__inner") || item;
      if (!innerElement) return;
      
      const productLink = innerElement.querySelector("a[href*='/products/']");
      if (!productLink) return;
      
      const handle = productLink.getAttribute('href');
      const prodData = await fetchProductData(handle);
      
      if (!prodData) return;
      
      const hasCoreBadge = productHasCoreBadgeFromTags(prodData?.tags);
      
      let badgeValue = "";
      const activeSwatch = innerElement.querySelector(".js-swatch-button[aria-current='true']") ||
                           innerElement.querySelector(".js-swatch-button.is-active") ||
                           innerElement.querySelector(".js-swatch-button");
      
      if (activeSwatch) {
        badgeValue = activeSwatch.getAttribute("data-badge")?.trim() || 
                     activeSwatch.getAttribute("data-badge-text")?.trim() || "";
      }
      
      const badgeContainer = innerElement.querySelector(".product-grid-item__image") || innerElement;
      if (!badgeContainer) return;
      
      let badgeWrapper = badgeContainer.querySelector(".product__badge");
      
      if (badgeValue || hasCoreBadge) {
        badgeWrapper = ensureBadgeContainer(badgeContainer);

        if (badgeWrapper) {
          badgeWrapper.style.display = "";
          badgeWrapper.style.visibility = "visible";
          badgeWrapper.style.opacity = "1";

          upsertTextBadge(badgeWrapper, badgeValue);
          upsertCoreBadge(badgeWrapper, hasCoreBadge);
        }
      }

      // Apply pro pricing if user is a pro customer
      if (window.calculatePriceFromTags && document.body.dataset.pro && prodData.price) {
        const priceEl = innerElement.querySelector('a.product-grid-item__price');
        if (priceEl) {
          const tags = Array.isArray(prodData.tags)
            ? prodData.tags
            : (prodData.tags || '').split(',').map(function(t) { return t.trim(); });
          const priceData = window.calculatePriceFromTags(prodData.price, tags);

          if (priceData.calculatedPrice < priceData.originalPrice) {
            const currencyCode = (window.theme && window.theme.moneyWithCurrencyFormat && window.theme.moneyWithCurrencyFormat.match(/[A-Z]+/g) || ['USD'])[0];
            const formatMoney = function(cents) {
              return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode }).format(cents / 100);
            };
            priceEl.innerHTML =
              '<span class="product-grid-item__price-new price">' + formatMoney(priceData.calculatedPrice) + '</span>' +
              '<span class="line-through">' + formatMoney(priceData.originalPrice) + '</span>';
          }
        }
      }

    } catch (error) {
      console.error('Error processing SS recommendation item:', error);
    }
  }

  function processAllRecommendations() {
    const allItems = document.querySelectorAll('.ss__result__item, .ss__result--item');
    allItems.forEach(processSSRecommendationItem);
    
    [100, 500, 1000].forEach(delay => {
      setTimeout(() => {
        const items = document.querySelectorAll('.ss__result__item, .ss__result--item');
        items.forEach(processSSRecommendationItem);
      }, delay);
    });
  }

  function waitForSearchSpring(callback) {
    let attempts = 0;
    const maxAttempts = 50;
    
    const checkInterval = setInterval(() => {
      attempts++;
      
      const ssRecommendations = document.querySelectorAll('.ss__result__item, .ss__result--item');
      
      if (ssRecommendations.length > 0 || attempts >= maxAttempts) {
        clearInterval(checkInterval);
        callback();
      }
    }, 100);
  }

  function initializeSSRecommendationsBadges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('ss__result__item') || node.classList?.contains('ss__result--item')) {
              setTimeout(() => processSSRecommendationItem(node), 50);
            }
            
            if (node.classList?.contains('swiper-slide')) {
              const ssResult = node.querySelector('.ss__result--item, .ss__result__item');
              if (ssResult) {
                setTimeout(() => processSSRecommendationItem(ssResult), 50);
              }
            }
            
            if (node.classList?.contains('ss__carousel') && node.classList?.contains('ss__carousel__recommendation')) {
              setTimeout(() => {
                const items = node.querySelectorAll('.ss__result__item, .ss__result--item');
                items.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50); // Stagger processing
                });
              }, 200);
            }
            
            if (node.classList?.contains('ss__tabbed__content')) {
              setTimeout(() => {
                const items = node.querySelectorAll('.ss__result__item, .ss__result--item');
                items.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50);
                });
              }, 300);
            }
            
            const items = node.querySelectorAll?.('.ss__result__item, .ss__result--item');
            items?.forEach((item, index) => {
              setTimeout(() => processSSRecommendationItem(item), index * 50);
            });
            
            const carousel = node.querySelector?.('.ss__carousel.ss__carousel__recommendation');
            if (carousel) {
              setTimeout(() => {
                const carouselItems = carousel.querySelectorAll('.ss__result__item, .ss__result--item');
                carouselItems.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50);
                });
              }, 200);
            }
            
            const tabbedContent = node.querySelector?.('.ss__tabbed__content');
            if (tabbedContent) {
              setTimeout(() => {
                const tabbedItems = tabbedContent.querySelectorAll('.ss__result__item, .ss__result--item');
                tabbedItems.forEach((item, index) => {
                  setTimeout(() => {
                    processSSRecommendationItem(item);
                  }, index * 50);
                });
              }, 300);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Wait for SearchSpring to load before initial processing
    waitForSearchSpring(() => {
      processAllRecommendations();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSSRecommendationsBadges);
  } else {
    initializeSSRecommendationsBadges();
  }
  
  // SearchSpring event handling
  function setupSearchSpringEvents() {
    if (window.SearchSpring?.on) {
      window.SearchSpring.on('afterSearch', () => {
        processAllRecommendations();
      });
      
      // Also listen for recommendation specific events
      window.SearchSpring.on('recommendationsLoaded', () => {
        processAllRecommendations();
      });
    }
  }
  
  if (window.SearchSpring) {
    setupSearchSpringEvents();
  } else {
    // Keep checking for SearchSpring
    let ssCheckInterval = setInterval(() => {
      if (window.SearchSpring) {
        setupSearchSpringEvents();
        clearInterval(ssCheckInterval);
      }
    }, 100);
    
    setTimeout(() => clearInterval(ssCheckInterval), 10000); // 10 seconds max
  }
  
  // Also listen for custom events that SearchSpring might fire
  document.addEventListener('searchspring:recommendations:loaded', () => {
    processAllRecommendations();
  });

  function setupSwatchClickHandlers() {
    document.addEventListener('click', async (event) => {
      const swatch = event.target.closest('.js-swatch-button, .siblings__swatch');
      if (!swatch) return;
      
      const item = swatch.closest('.ss__result--item, .ss__result__item');
      if (!item) return;
      
      const swatchHandle = swatch.getAttribute('href') || swatch.getAttribute('product-handle');
      if (swatchHandle) {
        const prodData = await fetchProductData(swatchHandle);
        if (prodData) {
          const innerElement = item.querySelector(".ss__result__inner") || item.querySelector(".card__inner") || item;
          const badgeContainer = innerElement.querySelector(".product-grid-item__image") || innerElement;
          
          const hasCoreBadge = productHasCoreBadgeFromTags(prodData?.tags);
          const badgeValue = swatch.getAttribute("data-badge")?.trim() || "";
          
          let badgeWrapper = badgeContainer.querySelector(".product__badge");
          
          if (badgeValue || hasCoreBadge) {
            badgeWrapper = ensureBadgeContainer(badgeContainer);
            if (badgeWrapper) {
              upsertTextBadge(badgeWrapper, badgeValue);
              upsertCoreBadge(badgeWrapper, hasCoreBadge);
              removeBadgeWrapperIfEmpty(badgeWrapper);
            }
          } else if (badgeWrapper) {
            badgeWrapper.remove();
          }
        }
      }
    });
  }
  
  setupSwatchClickHandlers();

  window.SSRecommendationsBadges = {
    processSSRecommendationItem,
    productHasCoreBadgeFromTags,
    fetchProductData
  };

})();